<div class="page">
  <div class="card fade-up">

    <div class="hud-title">PIXEL STARSHIPS</div>
    <div class="hud-subtitle">Pilot Authentication</div>

    <div class="error-msg" *ngIf="error">{{ error }}</div>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="field">
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          autocomplete="email"
          [formControl]="$any(form.get('email'))"
          [class.invalid]="form.get('email')!.invalid && form.get('email')!.touched"
          placeholder="pilot@example.com"
        />
      </div>

      <div class="field">
        <label for="password">Password</label>
        <input
          id="password"
          type="password"
          autocomplete="current-password"
          [formControl]="$any(form.get('password'))"
          [class.invalid]="form.get('password')!.invalid && form.get('password')!.touched"
          placeholder="••••••••"
        />
      </div>

      <button class="btn btn-primary" type="submit" [disabled]="loading">
        <span class="spinner" *ngIf="loading"></span>
        {{ loading ? 'Authenticating...' : 'Login' }}
      </button>
    </form>

    <button class="btn btn-ghost" (click)="back()" [disabled]="loading">
      ← Back to Accounts
    </button>

    <!-- Debug panel -->
    <div class="debug-panel">
      <div class="debug-header">
        <span>Diagnostics</span>
        <button class="btn-test" (click)="testServer()">Run Connection Test</button>
      </div>
      <div class="debug-log" *ngIf="debugLog.length > 0">
        <div *ngFor="let line of debugLog" [class.ok]="line.includes('✓')" [class.fail]="line.includes('✗')">
          {{ line }}
        </div>
      </div>
      <div class="debug-empty" *ngIf="debugLog.length === 0">
        Click "Run Connection Test" to check server connectivity, or attempt a login to see output here.
      </div>
    </div>

  </div>
</div>
